export default __webpack_public_path__ + "d3971b185c4db7bf1b90c5776608346c.png";